import { useState } from "react";
import { Button, IconButton, Tooltip } from "@mui/material";
import DataObjectOutlined from "@mui/icons-material/DataObjectOutlined";
import ResponseModal from "../response-modal";
import { ResponseQueryProps } from "../../types/query";

interface ResponseButtonProps {
	getResponses: () => Promise<Pick<ResponseQueryProps, "id" | "name">[]>;
	variant?: "icon" | "button";
	edge?: "end" | false;
}

export default function ResponseButton({
	getResponses,
	variant = "button",
	edge,
}: ResponseButtonProps) {
	const [open, setOpen] = useState(false);

	return (
		<>
			{variant === "icon" ? (
				<Tooltip title="Ver retorno" arrow>
					<IconButton
						edge={edge}
						aria-label="Ver retorno"
						onClick={() => setOpen(true)}
					>
						<DataObjectOutlined />
					</IconButton>
				</Tooltip>
			) : (
				<Button
					color="info"
					variant="outlined"
					disableElevation
					sx={{ ml: 1, "@media print": { display: "none" } }}
					onClick={() => setOpen(true)}
					startIcon={<DataObjectOutlined />}
				>
					Ver retorno
				</Button>
			)}

			<ResponseModal
				open={open}
				onClose={() => setOpen(false)}
				getResponses={getResponses}
			/>
		</>
	);
}
